<template>
    <div class="add-house-page">
        <Breadcrumb />
        <add-house-comp :class="{'fixed': listIsFixed}"></add-house-comp>
    </div>
</template>
<script>
import Breadcrumb from '@/components/widge/Breadcrumb.vue';
import AddHouseComp from '@/components/landlord/houseStatus/houseManagement/addHouse/AddHouseComp.vue';

export default {
    name: 'AddHouse',
    data () {
        return {
            listIsFixed: false
        }
    },
    created() {
        this.$store.dispatch('sendEventLog', 'CREATE_HOUSE')  
    },
    mounted () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('add-house-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('add-house-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    components: {
        Breadcrumb,
        AddHouseComp
    }
}
</script>
<style lang="scss" scoped>
    .add-house-page{
        position: relative;
        margin-top: 82px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/HouseManagementPages/AddHouse.vue